import React from "react";
import { Link } from "react-router-dom";

interface OurServicesCardProps {
  src: string;
  title: string;
  desc: string;
  linkTo?: string;
}

const OurServicesCard: React.FC<OurServicesCardProps> = ({
  src,
  title,
  desc,
  linkTo,
}) => {
  const cardContent = (
    <div className="our-services-card-container">
      <div className="our-services-card-image">
        <img loading="lazy" decoding="async" src={src} alt={title} />
      </div>

      <div className="our-services-card-title">
        <p>{title}</p>
      </div>

      <div className="our-services-card-desc">
        <p>{desc}</p>
      </div>
    </div>
  );

  if (linkTo) {
    return (
      <Link
        to={linkTo}
        target="_blank"
        rel="noopener noreferrer"
        className="our-services-card-link"
      >
        {cardContent}
      </Link>
    );
  }

  return cardContent;
};

export default OurServicesCard;
